import { Box } from '@mui/material'
import ViewActionButton from './ViewActionButton';
import ProductsActionButton from './ProductsActionButton';

interface Props {
  id: string;
}

export default function StoreActionButtons({ id }: Props) {
  return (
    <Box
      display={'flex'}
      gap={1}
    >
      <ViewActionButton path={`${id}`} />
      <ProductsActionButton path={`${id}/products`} />
    </Box>
  )
}
